import { z } from 'zod';

export const aiProviders = ['openai', 'anthropic'] as const;
export type AIProvider = (typeof aiProviders)[number];

export const openaiModels = [
  'gpt-4o',
  'gpt-4o-mini',
  'gpt-4-turbo',
  'gpt-3.5-turbo',
] as const;

export const anthropicModels = [
  'claude-sonnet-4-20250514',
  'claude-3-5-sonnet-20241022',
  'claude-3-haiku-20240307',
] as const;

export const aiSettingsSchema = z.object({
  provider: z.enum(aiProviders, {
    required_error: 'Debe seleccionar un proveedor',
  }),
  api_key: z.string()
    .min(1, 'La API key es requerida')
    .min(10, 'La API key parece ser inválida'),
  model: z.string()
    .min(1, 'Debe seleccionar un modelo'),
  is_enabled: z.boolean().default(true),
  max_tokens: z.number()
    .int('Debe ser un número entero')
    .min(100, 'Mínimo 100 tokens')
    .max(8000, 'Máximo 8000 tokens')
    .default(2000),
  temperature: z.number()
    .min(0, 'Mínimo 0')
    .max(2, 'Máximo 2')
    .default(0.7),
  system_prompt: z.string().optional(),
});

export type AISettingsInput = z.infer<typeof aiSettingsSchema>;

export interface AISettings {
  id: string;
  provider: AIProvider;
  api_key: string;
  model: string;
  is_enabled: boolean;
  max_tokens: number;
  temperature: number;
  system_prompt: string | null;
  created_at: string;
  updated_at: string;
}

export interface AIMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

export interface AIChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
}

export const getModelsForProvider = (provider: AIProvider): string[] => {
  if (provider === 'openai') {
    return [...openaiModels];
  }
  return [...anthropicModels];
};

export const getDefaultModelForProvider = (provider: AIProvider): string => {
  if (provider === 'openai') {
    return 'gpt-4o';
  }
  return 'claude-sonnet-4-20250514';
};
